import classnames from 'classnames';

import {TypographySize, useTypography} from '../../../hooks/typography';

import styles from './styles.module.css';

export type Props = {
    emoji?: {
        url: string;
        name?: string;
        size?: 16 | 24;
    };
    text?: string;
    expiration?: string;
};

const DEFAULT_EMOJI_SIZE = 16;

export const ProfileCustomStatus = (props: Props) => {
    const [expireTypographyCls, textTypographyCls] = useTypography([
        {
            size: TypographySize.BodyS,
        },
        {
            size: TypographySize.BodyL,
        },
    ]);

    const emojiSize = props.emoji?.size || DEFAULT_EMOJI_SIZE;
    const emoji = props.emoji && (
        <img
            className={classnames(styles.emoji, `${styles.emoji}-${emojiSize}`)}
            src={props.emoji.url}
            alt={props.emoji.name}
        />
    );
    const expiration = props.expiration ? (
        <span className={classnames(styles.expiration, expireTypographyCls)}>{props.expiration}</span>
    ) : null;
    const text = props.text ? <span className={textTypographyCls}>{props.text}</span> : null;

    return (
        <div
            className={classnames(styles.customStatus, {
                [styles.noText]: !props.text,
            })}
        >
            <div className={styles.textWrapper}>
                {emoji}
                {text}
            </div>
            {expiration}
        </div>
    );
};
